import { useLoadColumns } from './useLoadColumns';

type InvalidStepError = {
  data: {
    _reason: 'BAD_QUERY_LAYER';
    _layerId: number;
    _msg: string;
  };
};

const isInvalidStepError = (error: any): error is InvalidStepError =>
  error && 'data' in error && error.data._reason === 'BAD_QUERY_LAYER';

export const useInvalidStepId = (): Maybe<number> => {
  const { error } = useLoadColumns();

  return isInvalidStepError(error) ? error.data._layerId : null;
};

export const useInvalidStepMessage = (): Maybe<string> => {
  const { error } = useLoadColumns();

  return isInvalidStepError(error) ? error.data._msg : null;
};
